import * as $ from 'jquery';
import 'bootstrap';

export class memberHeader {

}
// let memberheader = new memberHeader();
